import { setContext } from '@apollo/client/link/context';
import { ApolloProvider, ApolloClient } from '@apollo/client';
import { InMemoryCache, createHttpLink } from '@apollo/client';

import { config } from "../config/config";

const httpLink = createHttpLink({
  uri: config.BACKEND_URL + "/graphql/"
})

const authLink = setContext((_: any, { headers }: any) => {
  // get the authentication token from local storage if it exists
  // return the headers to the context so httpLink can read them
  const strKey = `${config.FRONTEND_URL}-configauthToken`;
  const token = localStorage.getItem(strKey);

  return {
    headers: {
      ...headers, authorization: token || ''
    }
  }
})

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache()
})

const GraphQLProvider = ({ children }: any) => {
  return (
    <ApolloProvider client={client}>
      {children}
    </ApolloProvider>
  )
}

export { GraphQLProvider };